import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BasicModal from "../../../../core/BaseComponents/Modal";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { callAPI } from "../../../../../axios";
import { getChainIdLS } from "../../../../../utils/utils";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";

function CarouselComponent(props) {
  const sliderRef = useRef(null);
  const [reOrderImages, setReOrderImages] = useState([]);
  const [sequenceOrder, setSequenceOrder] = useState([]);
  const [reOrderDisabled, setReOrderDisabled] = useState('');
  const { chainId } = useSelector((state) => state.chainIdReducer);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: props?.initialSlide
  };

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const [reorderedItem] = sequenceOrder.splice(result.source.index, 1);
    sequenceOrder.splice(result.destination.index, 0, reorderedItem);

    callAPI(`/special/reorder?id=${props?.listConfigId}`, "PUT", sequenceOrder, { chainId: getChainIdLS() })
      .then(function (response) {
        reOrderList();
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const reOrderList = () => {
    callAPI(`/speciality-id?id=${props?.listConfigId}`, "GET", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setReOrderDisabled(res?.active)
        setReOrderImages(res?.imageResponse);
        setSequenceOrder(res?.imageResponse.map((item) => item?.id))
      })
      .catch((err) => {
        console.warn(err.message);
      });
  }

  useEffect(() => {
    reOrderList();
  }, [props, chainId]);

  const handleDelete = (url, id)=>{
    props?.handleDeleteBannerAPI(url, id)
  }

  const handleIntialSlideImage = (index)=>{
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  }
  
  return (
    <BasicModal
      popupOpen={props?.showPreviewPopUp}
      popupCloseHandler={() => { props.setShowPreviewPopUp(false); props?.hotelServiceListApi() }}
      isCross={true}
      heading={<p className="mb-2">Hotel Service Images Preview</p>}
      popupSize='col-10'
      bodyMessage={
        <>
          {
            reOrderImages?.length > 1 ? <>
              <Slider {...settings} ref={sliderRef} className="preview-slider-image mx-4">
                {reOrderImages?.map((bannerImagesList) =>
                  <img src={bannerImagesList?.imageUrl} alt={bannerImagesList?.id} />
                )}
              </Slider>
            </> : <div className="preview-banner-img">
              <img src={reOrderImages[0]?.imageUrl} alt={reOrderImages[0]?.id} width={100} />
            </div>
          }
          {reOrderImages.length > 1 &&
            <div className="mt-5">
              <h6 className="text-start mb-3">Re-Order / Delete Hotel Service Images</h6>
              {
                reOrderDisabled || props.editHotelSid.id === props.listConfigId ? <div className="delete-config-images justify-content-center">
                  {reOrderImages?.map((url) =>
                      <div>
                        <img
                          src={url?.imageUrl}
                          alt={url?.id}
                          className="undrag-images"
                        />
                        <Tooltip title={`${reOrderImages?.length === 1 ? 'At least one image required in hero banner' : reOrderDisabled ? "Un-Publish to perform actions" : props?.editHotelSid.id === props.listConfigId ? "Cancel edit mode to perform actions" : 'Delete'}`}>
                          <span className={`${reOrderImages?.length === 1 || reOrderDisabled || props?.editHotelSid.id === props.listConfigId ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => reOrderImages?.length === 1 || reOrderDisabled || props?.editHotelSid.id === props?.listConfigId ? "" : ""}>X</span>
                        </Tooltip>
                      </div>
                    )}
                </div> :
                  <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="droppable" direction="horizontal">
                      {(provided) => (
                        <div
                        className="delete-config-images justify-content-center"
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {reOrderImages?.map((url, index) => (
                            <Draggable key={String(url?.id)} draggableId={String(url?.id)} index={index}>
                              {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <img
                                      src={url?.imageUrl}
                                      alt={url?.id}
                                      className="drag-images"
                                      onClick={()=> handleIntialSlideImage(index)}
                                    />
                                    <Tooltip title={`${reOrderImages?.length === 1 ? 'At least one image required in hero banner' : reOrderDisabled ? "Un-Publish to perform actions" : props?.editHotelSid.id === url?.id ? "Cancel edit mode to perform actions" : 'Delete'}`}>
                                      <span className={`${reOrderImages?.length === 1 || reOrderDisabled || props?.editHotelSid.id === url?.id ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => reOrderImages?.length === 1 || reOrderDisabled || props?.editHotelSid.id === url?.id ? "" : handleDelete(url, props.listConfigId)}>X</span>
                                    </Tooltip>
                                  </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
              }
            </div>
          }
        </>
      }
    />
  );
}

export default CarouselComponent;
